/** Styles on the host element so fixed launcher/panel inside shadow DOM are not clipped. */
export function applyVoiceNavMountHostStyles(el: HTMLElement): void {
  el.style.setProperty('position', 'fixed')
  el.style.setProperty('inset', '0')
  el.style.setProperty('width', '0')
  el.style.setProperty('height', '0')
  el.style.setProperty('margin', '0')
  el.style.setProperty('padding', '0')
  el.style.setProperty('border', 'none')
  el.style.setProperty('overflow', 'visible')
  el.style.setProperty('pointer-events', 'none')
  el.style.setProperty('z-index', '2147483646')
  el.style.setProperty('background', 'transparent')
  el.dataset.vnwMount = '1'
}

export function showVoiceNavMountError(message: string): void {
  if (typeof document === 'undefined') return
  const id = 'vnw-mount-error-banner'
  if (document.getElementById(id)) return
  const el = document.createElement('div')
  el.id = id
  el.setAttribute(
    'style',
    [
      'position:fixed',
      'bottom:16px',
      'left:16px',
      'right:16px',
      'max-width:480px',
      'margin:0 auto',
      'padding:12px 14px',
      'background:#fef2f2',
      'border:1px solid #fecaca',
      'color:#991b1b',
      'font:13px/1.45 system-ui,-apple-system,Segoe UI,Roboto,sans-serif',
      'z-index:2147483647',
      'border-radius:10px',
      'box-shadow:0 10px 28px rgba(15,23,42,.18)',
      'pointer-events:auto',
    ].join(';'),
  )
  el.textContent = message
  document.body.appendChild(el)
}
